export default {
  methods: {
    sortCustomersByField (fieldName) {
      this.$store.dispatch('CustomersStore/sortCustomersByField', {
        fieldName
      })
    },
    isSortedByCustomerField (field) {
      const fields = Array.isArray(field) ? field : [field]
      const currentFiltersKeys = Object.keys(this.currentFilters)
      let isSortedBy = true
      fields.forEach(el => {
        if (!currentFiltersKeys.includes(`order[${el}]`)) isSortedBy = false
      })
      return isSortedBy
    },
    sortCustomerDirection (field) {
      if (!this.isSortedByCustomerField(field)) return false
      return this.currentFilters[`order[${field}]`]
    },
    getCustomerSortableClass (field) {
      const sorted = this.isSortedByCustomerField(field)
      const direction = this.sortCustomerDirection(field)
      const classList = []
      if (sorted) {
        classList.push('sorted')
        if (direction === 'DESC') {
          classList.push('reverse')
        }
      }
      return classList.join(' ')
    }
  },
  computed: {
    currentFilters () {
      return this.$store.getters['CustomersStore/filters']
    }
  }
}
